import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './AguardandoPagamento.module.css';

function PagamentoFalhou() {
  const navigate = useNavigate();
  const location = useLocation();
  const [mensagem, setMensagem] = useState('Falha ao processar o pagamento.');
  const [detalhe, setDetalhe] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const ref = params.get('ref');

    if (ref) {
      setDetalhe(`Referência do pedido: ${ref}`);
    }

    // Limpar carrinho e dados temporários
    localStorage.removeItem('carrinho');
    localStorage.removeItem('tipoEntrega');
    localStorage.removeItem('dataAgendada');
    localStorage.removeItem('horaAgendada');
    localStorage.removeItem('payment_reference');

    // Redirecionar automaticamente após 5 segundos
    const timer = setTimeout(() => {
      navigate('/carrinho');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate, location]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.iconContainer}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={styles.errorIcon}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12" y2="16" />
          </svg>
        </div>

        <h1 className={styles.titulo}>{mensagem}</h1>

        <p className={styles.descricao}>
          Ocorreu um problema ao tentar concluir seu pagamento no Mercado Pago.
          <br />
          {detalhe && <span>{detalhe}</span>}
        </p>

        <div className={styles.infoBox}>
          <p className={styles.infoText}>
            💡 <strong>Dica:</strong> Verifique se o cartão ou a conta utilizada está correta.
            Você será redirecionado ao carrinho em instantes.
          </p>
        </div>

        <button
          className={styles.botaoVoltar}
          onClick={() => navigate('/carrinho')}
        >
          Voltar agora
        </button>
      </div>
    </div>
  );
}

export default PagamentoFalhou;
